export class UnauthorizedApiError extends Error {
  constructor() {
    super('Your credentials could not be verified, please try again.')
    Object.setPrototypeOf(this, UnauthorizedApiError.prototype)
  }
}
